export interface PromocodeBase {
    id?: number; // Уникальный идентификатор
    code?: string; // Код промокода
    discount: number; // Размер скидки
    end_date: string; // Дата окончания действия (ISO)
    usage_limit: number; // Количество использований
    disable_usage_limit: boolean; // Отключить ограничение по использованию
    is_active: boolean; // Активен ли промокод
    shop_id?: number; // ID магазина
}

export interface PromocodeDTO extends PromocodeBase {
    quantity: number; // Количество создаваемых промокодов
}

export interface PromocodeFilters {
    limit: number;
    offset: number;
    page: number;
    shop_id: number;
}

export interface PromocodeRequest {
    id: number;
    shop_id: number;
}

export interface PromocodeDeleteRequest {
    shop_id: number;
    ids: number[];
}

export interface PromocodeResponse {
    code: number;
    message: null | string;
}

export const PROMOCODE_FORM_TYPE = {
    UNIQUE: 'unique',
    GENERATED: 'generated',
} as const;

export type PromocodeFormType =
    (typeof PROMOCODE_FORM_TYPE)[keyof typeof PROMOCODE_FORM_TYPE];

export const PAGE_TYPE = {
    CREATE: 'create',
    EDIT: 'edit',
};

export type PageType = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE];

export const PROMOCODE_FIELD_NAMES = {
    CODE: 'code',
    DISCOUNT: 'discount',
    QUANTITY: 'quantity',
    END_DATE: 'end_date',
    USAGE_LIMIT: 'usage_limit',
    DISABLE_USAGE_LIMIT: 'disable_usage_limit',
    IS_ACTIVE: 'is_active',
};

export type FieldName =
    (typeof PROMOCODE_FIELD_NAMES)[keyof typeof PROMOCODE_FIELD_NAMES];
